// extracted by mini-css-extract-plugin
export var inView = "Dash-module--inView--IoONz";
export var wrapper = "Dash-module--wrapper--Q85nM";